// 宿主环境所提供的路由参数
export enum HostRouteParamsEnum {
  // 默认token,登录态
  TOKEN = 'token',
  // 默认subject_id
  SUBJECT_ID = 'hostSubjectId',
  // 默认subject_name
  SUBJECT_NAME = 'hostSubjectName',
}

export enum StorageKeyEnum {
  HOST_PROGRAM_SUBJECT_ID = 'HOST_PROGRAM_SUBJECT_ID',
}
